import { logger } from '@sanlam-glacier/app-common/modules/logger';

export const AppStartupError = () => {
  logger.error({ message: 'Config or Design Provider Failed' });

  window.location.replace(window.location.origin);
  return <></>;
};
